import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './index.css';

const SearchPage = () => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL
    const handleSearch = async (e) => {
        e.preventDefault();
        if (!query) return;

        try {
            const response = await fetch(`${apiUrl}apps/search/?q=${query}`);
            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }
            const data = await response.json();
            setResults(data);
        } catch (error) {
            console.error('Error fetching search results:', error);
        }
    };

    const truncateText = (text, maxLength) => {
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    };

    const handleViewApp = (id) => {
        navigate(`/app/${id}`);
    };

    return (
        <div className="app-list search-page">
            <h1>Search Apps</h1>
            <form onSubmit={handleSearch} className="search-form">
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Search for apps..."
                    className="search-input"
                />
                <button type="submit" className="search-button">Search</button>
            </form>

            <div className="search-results">
                {results.length > 0 ? (
                    <ul>
                        {results.map(result => (
                            <li key={result.id} className="app-item">
                                <div className="appListIcon">
                                    <img 
                                        src={`${apiUrl}${result.icon}`} 
                                        alt={`${result.name} icon`} 
                                        className="app-icon" 
                                    />
                                </div>
                                <div className="app-details">
                                    <h2>{result.name}</h2>
                                    <p>{truncateText(result.description, 50)}</p>
                                    <p className="rating">{result.rating} ★</p>
                                </div>
                                <div className="app-action">
                                    <FontAwesomeIcon 
                                        icon={faArrowRight} 
                                        onClick={() => handleViewApp(result.id)} 
                                        className="view-app-icon"
                                    />
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    query && <p>No results found.</p>
                )}
            </div>
        </div>
    );
};

export default SearchPage;
